'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colors = require('../base/colors.js');
var index = require('../utils/index.js');
var colors_bg = require('./colors.bg.js');

/**
 * Border Colors with light-dark() function applied and detailed comments.
 */ const borderColor = {
    neutral: {
        DEFAULT: `light-dark(${index.opacity(colors.colors.black['900'], 30)}, ${index.opacity(colors.colors.white, 30)})`,
        subtle: `light-dark(${index.opacity(colors.colors.black['900'], 10)}, ${index.opacity(colors.colors.white, 10)})`,
        strong: `light-dark(${index.opacity(colors.colors.black['900'], 50)}, ${index.opacity(colors.colors.white, 50)})`
    },
    selected: {
        neutral: `light-dark(${colors.colors.black['600']}, ${colors.colors.black['25']})`
    },
    interactive: {
        strong: `light-dark(${index.opacity(colors.colors.blue['600'], 50)}, ${index.opacity(colors.colors.blue['200'], 70)})`
    },
    focus: `light-dark(${colors.colors.blue['300']}, ${colors.colors.blue['300']})`,
    information: `light-dark(${index.opacity(colors.colors.blue['600'], 30)}, ${index.opacity(colors.colors.blue['200'], 30)})`,
    success: `light-dark(${index.opacity(colors.colors.green['600'], 30)}, ${index.opacity(colors.colors.green['200'], 30)})`,
    warning: `light-dark(${index.opacity(colors.colors.yellow['600'], 30)}, ${index.opacity(colors.colors.yellow['300'], 30)})`,
    error: `light-dark(${index.opacity(colors.colors.red['600'], 30)}, ${index.opacity(colors.colors.red['200'], 50)})`,
    focusError: `light-dark(${colors.colors.red['500']}, ${colors.colors.red['300']})`,
    processing: `light-dark(${index.opacity(colors.colors.violet['600'], 30)}, ${index.opacity(colors.colors.violet['200'], 30)})`
};
/**
 * Border Gradient.
 */ const borderGradient = {
    selected: `linear-gradient(${colors_bg.backgroundColor.surface.primary}, ${colors_bg.backgroundColor.surface.primary}), linear-gradient(68deg, light-dark(${colors.colors.blue['200']}, ${colors.colors.blue['300']}) 0%, light-dark(${colors.colors.purple['200']}, ${colors.colors.purple['300']}) 100%)`,
    'selected-neutral': `linear-gradient(${colors_bg.backgroundColor.neutral.DEFAULT}, ${colors_bg.backgroundColor.neutral.DEFAULT}), linear-gradient(68deg, light-dark(${colors.colors.blue['200']}, ${colors.colors.blue['300']}) 0%, light-dark(${colors.colors.purple['200']}, ${colors.colors.purple['300']}) 100%)`,
    'selected-warning': `linear-gradient(${colors_bg.backgroundColor.warning}, ${colors_bg.backgroundColor.warning}), linear-gradient(68deg, light-dark(${colors.colors.blue['200']}, ${colors.colors.blue['300']}) 0%, light-dark(${colors.colors.purple['200']}, ${colors.colors.purple['300']}) 100%)`
};
/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    theme: {
        extend: {
            borderColor,
            borderGradient
        }
    }
};

exports.borderColor = borderColor;
exports.borderGradient = borderGradient;
exports.default = preset;
//# sourceMappingURL=colors.border.js.map
